var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page auth-wrap"},[_c('div',{staticClass:"auth-head"},[_c('div',{staticClass:"auth-head__logo"},[_c('a',{attrs:{"href":'https://skladusa.com/' + _vm.getLangPrefix,"target":"_blank"}},[_c('img',{attrs:{"src":"/img/login-group/login-logo.png","alt":"alt"}})])])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }